module.exports = __webpack_public_path__ + "img/2.2e5c3bd6.png";